import { ClientInfo } from './clientinfo';

export class RequestInfo {
    requestNumber: number;
    requestType: string;
    category: string;
    itemType: string;
    item: string;
    createdDate: string;
    closedDate: string;
    status: string;
    technician: string;
    subject: string;
    hasAttachment: boolean;
    room: string;
    priority: string;
    classification: string;
    description: string;
    requestor: string;
    ccList: ClientInfo[];
    canApprove: boolean;
    isOnNeedinfo: boolean;
    isAwaitingMyApproval: boolean;
    solutionId: number;
    solutionText: string;
    isSolutionWorkAround: boolean;
    updatedOn: string;
}
